import { render, staticRenderFns } from "./MenusComponent.vue?vue&type=template&id=7ab4a3a8&scoped=true&"
import script from "./MenusComponent.vue?vue&type=script&lang=js&"
export * from "./MenusComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenusComponent.vue?vue&type=style&index=0&id=7ab4a3a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab4a3a8",
  null
  
)

export default component.exports